import { Box, type SxProps, type Theme, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { INK, NEUTRAL } from "../../../../../../theme/tokens";

interface PaneHeaderProps {
	/** Already-translated pane title (e.g. "Map HRIS roles to jobs"). */
	title: ReactNode;
	/** Already-translated one-line hint clarifying what this pane is for. */
	hint: ReactNode;
	/** Optional trailing slot (e.g. a count or status legend), right-aligned on the title row. */
	endingContent?: ReactNode;
	dataTestId?: string;
}

const TITLE_SX: SxProps<Theme> = { fontWeight: 600, fontSize: "0.875rem", lineHeight: 1.3, color: INK.SECONDARY };
const HINT_SX: SxProps<Theme> = { fontSize: "0.75rem", lineHeight: 1.4, color: NEUTRAL[500] };

/** Shared title + hint header for the two HRIS Job Alignment panes, so each announces its role. */
export const PaneHeader: FC<PaneHeaderProps> = ({ title, hint, endingContent, dataTestId }) => (
	<Box sx={{ display: "flex", flexDirection: "column", gap: 0.25, width: "100%" }} data-testid={dataTestId}>
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
			<Typography component="h3" sx={TITLE_SX}>
				{title}
			</Typography>
			{endingContent}
		</Box>
		<Typography component="p" sx={HINT_SX}>
			{hint}
		</Typography>
	</Box>
);
